/**
 * Snapshot por defecto de Reportes Diarios.
 * seed.ts recarga este snapshot cuando la tabla `rds` está vacía,
 * para conservar escenarios de prueba tras un reset de la base de datos.
 */

import type { Rd } from "@app-types/entities";
import { crearSnapshotStore } from "@/lib/snapshotDefault";
import { localDb } from "@core/data/adapters/dexie/db";

const rdStore = crearSnapshotStore<Rd>("pmis.rdsDefault");

/** Snapshot de RDs para seed.ts (null si no hay). */
export const leerRdsDefault = (): Rd[] | null => rdStore.leer();

/**
 * Congela el estado actual de los RDs leyendo directamente de la base
 * Dexie. Devuelve el número de RDs guardados.
 */
export async function guardarRdComoDefault(): Promise<number> {
  const rds = await localDb.rds.toArray();
  rdStore.guardar(rds);
  return rds.length;
}

/** Elimina el snapshot de RDs. */
export function borrarRdDefault(): void {
  rdStore.borrar();
}

/** Indica si hay un snapshot de RDs guardado. */
export function existeRdDefault(): boolean {
  return rdStore.existe();
}
